import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import '../stylesheets/ModalOp.css';
class TransactionConfirmModal extends React.Component {
  printOrder = () => {
    var mywindow = window.open('', 'PRINT', 'height=400,width=600');

    mywindow.document.write('<html><head><title> Transaction </title>');
    // mywindow.document.write( "<link rel=\"stylesheet\" href=\"style.css\" type=\"text/css\" media=\"print\"/>" );
    mywindow.document.write('<link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/4.4.1/css/bootstrap.min.css"/>');
    // <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/4.4.1/css/bootstrap.min.css"/>
    mywindow.document.write('</head><body >');
    mywindow.document.write(document.getElementById('printme').innerHTML);
    mywindow.document.write('</body></html>');

    mywindow.document.close();
    mywindow.focus();
    setTimeout(() => {
      // mywindow.focus();
      mywindow.print();
      mywindow.close();
    }, 400);
    // mywindow.print();
    // mywindow.close();

    return true;
  }
  handleClose = () => this.props.closeModal();
  render() {
    return (
      <Modal show={this.props.show} backdrop="static" onHide={this.handleClose} animation={false}>
        <div id="printme">
          <Modal.Header>
            <Modal.Title>{this.props.buttonText.TrxDetail}</Modal.Title>
          </Modal.Header>
          <Modal.Body className="my-modal-body"><pre>{this.props.result}</pre></Modal.Body>
        </div>
        <Modal.Footer>
          <Button variant="secondary" id="closeTransactionDialogue" onClick={this.handleClose}>
            {this.props.buttonText.Close}
          </Button>
          <Button variant="primary" id="PrintResult" onClick={this.printOrder}>
            {this.props.buttonText.Print}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}
export default TransactionConfirmModal;